<ul [ngClass]="['hk-vl-checklist']">
	<input type="text" [ngClass]="['hk-vl-checklist__search']" [formControl]="search" placeholder="Buscar" />
	<ng-container *ngFor="let option of options | searchLocal : search.value">
		<button
			[ngClass]="['hk-vl-checklist__option']"
			[disabled]="option.disabled ?? false"
			(click)="toggleOptions(option)"
		>
			<span [ngClass]="['hk-vl-checklist__option__box', value.includes(option.value) ? 'selected' : '']" [ngStyle]="{ '--pink-2': colorCheck }"></span>
			<span [ngClass]="['hk-vl-checklist__option__label']">{{ option.label }}</span>
		</button>
	</ng-container>
	<ng-container *ngIf="(options | searchLocal : search.value).length === 0">
		<li [ngClass]="['hk-vl-checklist__option']">
			{{ customMsgNotOptions ?? 'No disponible' }}
		</li>
	</ng-container>
</ul>
